import { render, staticRenderFns } from "./tableTextBar.vue?vue&type=template&id=0906a392&scoped=true&"
import script from "./tableTextBar.vue?vue&type=script&lang=ts&"
export * from "./tableTextBar.vue?vue&type=script&lang=ts&"
import style0 from "./tableTextBar.vue?vue&type=style&index=0&id=0906a392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906a392",
  null
  
)

export default component.exports